import * as React from 'react';
import { Typography } from '@material-ui/core';

import { Root, RouteList, UploadForSearch } from '../containers';

const uploadDocumentPage: React.SFC = () => {
  return (
    <Root routeList={<RouteList />}>
      <Typography variant="h5" gutterBottom>
        契約文書の比較 <br />
      </Typography>
      <Typography variant="h6" gutterBottom>
        　・複数の契約文書を並べて比較<br />
        <br />
        比較対象のファイル（最大３文書まで）をアップロードしてください
      </Typography>
      <UploadForSearch />
    </Root>
  );
};

export default uploadDocumentPage;



// WEBPACK FOOTER //
// ./src/pages/uploadForSearch.tsx